import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import ProductFeed from "../components/ProductFeed";

const HERO_IMG = "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products", { params: { category: "nuovi-arrivi" } })
      .then((r) => setProducts(r.data.products))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="home-page">
      {/* Hero full-bleed */}
      <section className="relative h-[82vh] max-h-[820px] overflow-hidden" data-testid="hero">
        <img src={HERO_IMG} alt="Boutique Dorae" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-black/20" />
        <div className="absolute bottom-0 left-0 p-7 pb-10 sm:p-12">
          <p className="text-[11px] font-semibold tracking-wide-spaced uppercase text-[#E3C565] mb-3" data-testid="hero-eyebrow">
            Dorae · Nuova stagione
          </p>
          <h1 className="font-sans font-medium text-white text-2xl sm:text-4xl leading-snug tracking-wide-spaced uppercase" data-testid="hero-headline">
            Scopri la nostra<br />collezione
          </h1>
          <Link
            to="/categoria/nuovi-arrivi"
            data-testid="hero-cta"
            className="inline-block mt-6 bg-white text-[#2C2C2C] px-10 py-3.5 text-[12px] font-semibold tracking-wide-spaced uppercase hover:bg-[#FAF7F2] transition-colors duration-300"
          >
            Acquista ora
          </Link>
        </div>
      </section>

      {/* Nuovi arrivi feed */}
      <section className="max-w-5xl mx-auto pt-14 pb-20" data-testid="home-feed-section">
        <div className="text-center mb-10 px-4">
          <h2 className="font-display text-3xl text-[#2C2C2C]">Nuovi arrivi</h2>
          <div className="gold-line w-24 mx-auto mt-4" />
        </div>
        <ProductFeed products={products} loading={loading} />
      </section>
    </div>
  );
}
